import { Dispatch, SetStateAction } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IntegranteDisponible, resetEquipoCustom } from '../../../store/equiposVentaSlice';
import { EquipoVentas } from '../../../types/vendedor';
import { CircularProgress } from '@mui/joy';
import { CancelButton } from '../../UtilitiesComponents/CancelButton';
import { ErrorMessage } from '../../UtilitiesComponents/ErrorMessage';
import { EquiposDisponibles } from './EquiposDisponibles';
import { IntegrantesNuevoEquipo } from './IntegrantesNuevoEquipo';
import { selectCurrentUserRole } from '../../../api/auth/authSlice';

interface Props {
    handleCreateCustomTeam: () => Promise<void>;
    equiposDisponibles?: EquipoVentas[];
    isLoading: boolean;
    errorMessage: string | null;
    setErrorMessage: Dispatch<SetStateAction<string | null>>;
    enableSaveButton: boolean;
    primerIntegrante?: IntegranteDisponible;
    segundoIntegrante?: IntegranteDisponible;
    textoNuevoEquipo: string;
}

export function FormularioCreacionEquipos({ 
    enableSaveButton,
    errorMessage,
    setErrorMessage,
    equiposDisponibles,
    handleCreateCustomTeam,
    isLoading ,
    primerIntegrante,
    segundoIntegrante,
    textoNuevoEquipo,
}: Props) {
    const dispatch = useDispatch();
    const userRole = useSelector(selectCurrentUserRole);

    if (userRole !== "Administrador")
        return (<div></div>);

    return (
        <div className="h-full flex-1 min-h-0 flex flex-col gap-y-2">

            <IntegrantesNuevoEquipo 
                titulo={textoNuevoEquipo}
                primerIntegrante={primerIntegrante}
                segundoIntegrante={segundoIntegrante}/>

            <div className="flex justify-center gap-x-3 h-[25px]">
                {isLoading
                ?
                <CircularProgress sx={{ 
                    height: 27,
                    width: 27,
                    "--CircularProgress-size": "25px",
                    "--CircularProgress-trackThickness": "4px",
                    "--CircularProgress-progressThickness": "4px"
                }}/>
                :
                <>
                <button 
                    onClick={handleCreateCustomTeam}
                    disabled={!enableSaveButton}
                    type="button"
                    className="bg-green-800 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center disabled:opacity-50">
                    <p className="text-white text-[13px] font-semibold text-center">Guardar</p>
                </button>
                <CancelButton onClick={() => {
                    dispatch(resetEquipoCustom());
                    setErrorMessage(null);
                }}/>
                </>
                }
            </div>

            {errorMessage && (
                <div className="my-2">
                    <ErrorMessage
                        customMessage>
                        <p className="text-sm">{errorMessage}</p>
                    </ErrorMessage>
                </div>
            )}

            <EquiposDisponibles
                equiposDisponibles={equiposDisponibles}/>

        </div>
    );
}